import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {
  ApexChart,
  ApexNonAxisChartSeries,
  ApexAxisChartSeries,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ChartComponent,
  ApexPlotOptions,
  ApexFill,
  ApexStroke,
  ApexLegend
} from 'ng-apexcharts';
import { ChartColors, ChartOptions } from '../chart-option-modal';

declare global {
  interface Window {
    Apex: any;
  }
}

window.Apex = {
  chart: {
    toolbar: {
      show: false
    }
  },
  tooltip: {
    shared: false
  },
  legend: {
    show: false
  }
};


@Component({
  selector: 'app-common-chart',
  templateUrl: './common-chart.component.html',
  styleUrl: './common-chart.component.scss'
})

export class CommonChartComponent implements OnInit, OnChanges {
  @ViewChild('chart') chart!: ChartComponent;
  @Input() chartOptions!: Partial<ChartOptions>;

  arrayData: any

  chartColors: any[] = ChartColors

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}



